import Box from "@mui/material/Box";
import { AddButton } from "app/components/Button/AddButton";
import BreadCrumb from "app/components/BreadCrumb";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import AddItemsModal from "./components/AddItemsModal";
import ItemsTable from "./components/ItemsTable";
import { selectItemsList, selectItemsLoading } from "./redux/selector";
import itemsSaga from "./redux/saga";
import { itemsActions, reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";

const Items = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: itemsSaga,
  });

  useEffect(() => {
    dispatch(itemsActions.getItemsList());
  }, [dispatch]);

  const rows = useSelector(selectItemsList);
  const loading = useSelector(selectItemsLoading);

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <Box className={styles.pageHeader}>
            <BreadCrumb title={t("SIDEBAR.ITEMS")} iconPosition="end" />
            <Box dir="ltr">
              <AddButton
                label={t("ITEMS.ACTIONS.ADD")}
                onClick={() => dispatch(itemsActions.openAddModal())}
              />
            </Box>
          </Box>
          <Box className={styles.tableWrapper}>
            <ItemsTable rows={rows} loading={loading} />
          </Box>
        </Box>
      </Box>
      <AddItemsModal />
    </Box>
  );
};

export default Items;
